module.exports = __webpack_public_path__ + "media/tlo-ap9.8dad5af1.mp4";